import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useLanguage } from "../../context/LanguageContext";
import { useAuth } from "../../context/AuthContext";
import { useToast } from "../../context/ToastContext";
import translations from "../../locals/translations.json";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import api from "../../lib/api.ts";
import { getPageSettings } from "../../services/pagesettingServices.ts";
dayjs.extend(utc);
dayjs.extend(timezone);

const DUBAI_TZ = "Asia/Dubai";

// const NotificationBar = ({ isLiveBidPage = false, auctionData = null, slidingBanner = "" }) => {
  const NotificationBar = ({ isLiveBidPage = false, auctionData = null}) => {
  const { language } = useLanguage();
  const { isAuthenticated, user } = useAuth();
  const { showWarning } = useToast();
  const navigate = useNavigate();
  const [shouldShowButton, setShouldShowButton] = useState(false);
  const [slidingBanner, setSlidingBanner] = useState("");

  // Check if there's a live auction or one starting within 30 minutes
  useEffect(() => {
    if (isLiveBidPage && auctionData) {
      // Always show button on live bid page
      setShouldShowButton(true);
      return;
    }

    const checkAuctions = async () => {
      try {
        // Fetch live auctions
        const liveRes = await api.get("/auctions/paginated", {
          params: {
            page: 1,
            limit: 50,
            orderBy: "startDate",
            order: "ASC",
            type: "live",
            filters: {
              unSoldVehicles: 1,
            },
          },
        });

        const liveAuctions = liveRes.data?.data || [];
        
        // Check if there are any live auctions
        if (liveAuctions.length > 0) {
          setShouldShowButton(true);
          return;
        }

        // Fetch upcoming auctions
        const upcomingRes = await api.get("/auctions/paginated", {
          params: {
            type: "upcomming",
            orderBy: "startDate",
            order: "ASC",
            filters: { isActive: true },
            limit: 10,
          },
        });

        const upcomingAuctions = upcomingRes.data?.data || [];
        const nowTz = dayjs().tz(DUBAI_TZ);

        // Check if any auction is starting within 30 minutes
        const hasAuctionStartingSoon = upcomingAuctions.some((auction) => {
          if (!auction.startDate) return false;

          const startTz = dayjs.utc(auction.startDate).tz(DUBAI_TZ);
          const msUntilStart = startTz.diff(nowTz);
          const minutesUntilStart = msUntilStart / (60 * 1000);

          // Show if auction is starting within 30 minutes or has already started
          return minutesUntilStart <= 30 && minutesUntilStart >= -60; // Allow 1 hour buffer for already started
        });

        setShouldShowButton(hasAuctionStartingSoon);
      } catch (error) {
        console.error("Error checking auctions:", error);
        // Don't show button on error
        setShouldShowButton(false);
      }
    };

    checkAuctions();
    // Check every minute to update button visibility
    const interval = setInterval(checkAuctions, 60000);
    return () => clearInterval(interval);
  }, [isLiveBidPage, auctionData]);
  useEffect(() => {
  let cancelled = false;

  const fetchBanner = async () => {
    try {
      const response = await getPageSettings({
        page: "homepage",
        lang: language,
      });

      const banner = response.sliding_banner || [];

      if (!cancelled) {
        setSlidingBanner(banner[0]?.title?.value || "");
      }
    } catch (error) {
      console.error("Error fetching sliding banner:", error);
    }
  };

  fetchBanner();

  return () => {
    cancelled = true;
  };
}, [language]);

  const handleJoinNow = () => {
    // Check if user is not logged in or is a seller
    if (!isAuthenticated || user?.userType === "seller") {
      showWarning("Log in as buyer to join auction", {
        duration: 3000,
      });
      return;
    }

    // If user is a buyer, redirect to auction page
    if (user?.userType === "buyer") {
      navigate("/auctions");
    }
  };
  return (
    <div className='bg-gradient-to-r from-orange-500 via-black to-orange-500 h-[40px] sticky top-16 z-40 flex items-center justify-center overflow-hidden'>
      {/* Container with max width */}
      <div className='w-full  max-w-6xl mx-auto  flex items-center gap-3 justify-between overflow-hidden'>
        {/* Marquee content that will scroll */}
        <div className=' overflow-hidden w-full'>
          <div className='animate-marquee  flex items-center space-x-2 md:space-x-8 lg:space-x-12 font-Poppins   md:text-[22px] text-white whitespace-nowrap'>
            {isLiveBidPage && auctionData ? (
              <>
                <div className=''>
                  🏷️ Live Auction: {auctionData.auctionName || "Live Auction"}
                </div>

                <div className='border-[1px] h-4 md:h-8 border-r border-[#FFFFFF]' />

                <div className=''>🔥 Lane:{auctionData?.laneName || "-"}</div>
              </>
            ) : (
              <>
                <div className=''>
                  🏷️ {slidingBanner}
                </div>
              </>
            )}
          </div>
        </div>

        {shouldShowButton && (
          <button
            onClick={handleJoinNow}
            className='bg-black text-white p-[10px]   md:text-[16px] font-normal flex-shrink-0 transition-colors duration-200 ml-4 skew-x-[-12deg] mx-4  border-[2px] border-[#FFFFFF] hover:bg-[#f06f15] '
          >
            {translations[language].home.notification.joinNowButton}
          </button>
        )}
      </div>
    </div>
  );
};

export default NotificationBar;
